import React, { useMemo, useState } from 'react';
import Select from 'react-select'
import { ClaimModel as ClaimModelInterface } from '../../models/APIModels';
import { Controller, useForm } from 'react-hook-form';
import { ApiHelper } from '../../common/ApiHelper';
import Button from '../Button';
import useAppUtils from '../../Utils/useAppUtils';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
interface IProps {
  userId: string,
  modelId: string,
  open: boolean;
  close: () => void;
}

const ClaimModel = ({ userId, modelId, open, close }: IProps) => {
  const { register, control,setValue, handleSubmit } = useForm<ClaimModelInterface>({
   
  });
  const { alert } = useAppUtils();
  const onSubmit = async(data:ClaimModelInterface) => {
   
    data.RequestingUserId = userId;
    data.modelId = modelId;
    const response = await ApiHelper.ClaimModel(data);
    if(response) {
      alert('Request Submitted! Please allow 72 hours for our team to review your request and reach back out to you.')
      close();
    }
  }
  return (
    <div>
      <Dialog open={open} onClose={close}>
        <form className="form" onSubmit={handleSubmit(onSubmit)}>
          <h4 style={{ textAlign: 'center' }}>Request to Take Ownership of a Model</h4>
          <DialogContent>
            <Controller
              control={control}
              name="contactName"
              render={({ field: { ref, ...fieldProps } }) => (
                <TextField
                  id="name"
                  margin="dense"
                  label="Contact Name"
                  placeholder="Contact Name"
                  type="text"
                  fullWidth
                  required
                  variant="outlined"
                  size="small"
                  {...fieldProps}
                />
              )}
            />
            <Controller
              control={control}
              name="contactemail"
              render={({ field: { ref, ...fieldProps } }) => (
                <TextField
                  margin="dense"
                  id="email"
                  label="Contact Email"
                  type="email"
                  fullWidth
                  required
                  variant="outlined"
                  size="small"
                  {...fieldProps}
                />
              )}
            />
            <Controller
              control={control}
              name="companyName"
              render={({ field: { ref, ...fieldProps } }) => (
                <TextField
                  id="compName"
                  margin="dense"
                  label="Company Name"
                  type="text"
                  fullWidth
                  required
                  variant="outlined"
                  size="small"
                  {...fieldProps}
                />
              )}
            />
            <Controller
              control={control}
              name="reason"
              render={({ field: { ref, ...fieldProps } }) => (
                <TextField
                  id="reason"
                  margin="dense"
                  label="Reason for the request"
                  type="textarea"
                  fullWidth
                  variant="outlined"
                  size="small"
                  multiline
                  required
                  minRows={3}
                  maxRows={5}
                  {...fieldProps}
                />
              )}
            />
          </DialogContent>
          <DialogActions>
            <Button variant="contained" rounded type="submit">
              Submit
            </Button>
            <Button variant="contained" rounded onClick={close}>
              Cancel
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};

export default ClaimModel;
